<template>
  <el-dialog
    title="用户信息"
    :visible.sync="dialogInfo"
    width="600px"
    :before-close="handleClose"
  >
    <span>
      <el-descriptions column="1" border="true">
        <el-descriptions-item label="用户名">{{
          userInfos.username
        }}</el-descriptions-item>
        <el-descriptions-item label="email">
          <el-input
            :placeholder="userInfos.email"
            v-model="email"
            :disabled="emailDisabled"
            style="width: 350px;margin-right: 10px"
            size="mini"
          >
          </el-input>
          <el-button
            v-if="emailDisabled"
            type="warning"
            size="mini"
            icon="el-icon-edit"
            @click="inputEmail"
            circle
          ></el-button>
          <el-button
            v-if="!emailDisabled"
            type="success"
            size="mini"
            icon="el-icon-check"
            @click="updateEmail"
            circle
          ></el-button>
        </el-descriptions-item>
        <el-descriptions-item label="密码">
          <div v-if="!passwordDisabled">
            <el-row :gutter="20">
              <el-col :span="5"><el-tag>原密码</el-tag></el-col>
              <el-col :span="15"
                ><el-input v-model="password" size="mini"></el-input>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top: 3px">
              <el-col :span="5"><el-tag>新密码</el-tag></el-col>
              <el-col :span="15">
                <el-input v-model="newPassword" size="mini"> </el-input>
              </el-col>
              <el-col :span="2">
                <el-button
                  type="success"
                  size="mini"
                  icon="el-icon-check"
                  circle
                  @click="updatePassword"
                ></el-button>
              </el-col>
            </el-row>
          </div>
          <el-button
            v-if="passwordDisabled"
            class="btns"
            size="mini"
            type="warning"
            @click="inputPassword"
            >修改密码
          </el-button>
        </el-descriptions-item>
        <el-descriptions-item label="是否为管理员">{{
          userInfos.is_admin
        }}</el-descriptions-item>
      </el-descriptions>
    </span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from "vuex";
import User from "@/models/user";

export default {
  name: "UserInfo",
  data() {
    return {
      dialogInfo: false,
      userInfos: {},
      email: "",
      emailDisabled: true,
      Editing: false,
      passwordDisabled: true,
      password: "",
      newPassword: ""
    };
  },
  methods: {
    ...mapActions("user", ["logout"]),
    resetDialog() {
      this.emailDisabled = true;
      this.Editing = false;
      this.passwordDisabled = true;
    },
    dialogShow() {
      User.getUsers()
        .then(response => {
          this.userInfos = response.data.user;
          this.dialogInfo = true;
          this.email = this.userInfos.email;
        })
        .catch(error => {
          this.$message.error(error.response.data.message);
          this.userInfos = {};
          this.email = "";
        });
    },
    inputEmail() {
      this.emailDisabled = false;
      this.Editing = true;
    },
    settingEmail() {
      User.updateEmail({ email: this.email })
        .then(() => {
          this.$message.success("修改成功!");
          this.dialogShow();
        })
        .catch(error => {
          this.$message.error(error.response.data.message);
        });
    },
    updateEmail() {
      this.$confirm("此操作将永久修改email, 是否继续?", "提示", {
        confirmButtonText: "确定修改",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.settingEmail();
        })
        .catch(() => {});
      this.resetDialog();
    },
    inputPassword() {
      this.passwordDisabled = false;
      this.Editing = true;
      this.password = "";
      this.newPassword = "";
    },
    settingPassword() {
      User.updatePassword({
        password: this.password,
        newPassword: this.newPassword
      })
        .then(() => {
          this.$message.success("修改密码成功,请重新登陆!");
          this.dialogInfo = false;
          this.logout();
        })
        .catch(error => {
          this.$message.error(error.response.data.message);
        });
    },
    updatePassword() {
      this.$confirm(
        "此操作将永久修改密码,修改成功后将退出登陆重新登录 是否继续?",
        "提示",
        {
          confirmButtonText: "确定修改",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          this.settingPassword();
        })
        .catch(() => {});
      this.resetDialog();
    },
    closeDialog() {
      if (!this.Editing) {
        this.resetDialog();
        this.dialogInfo = false;
      } else {
        this.$confirm("有未保存的数据,确认关闭？")
          .then(() => {
            this.resetDialog();
            this.dialogInfo = false;
          })
          .catch(() => {});
      }
    },
    handleClose(done) {
      if (!this.Editing) {
        this.resetDialog();
        done();
      } else {
        this.$confirm("有未保存的数据,确认关闭？")
          .then(() => {
            this.resetDialog();
            done();
          })
          .catch(() => {});
      }
    }
  }
};
</script>

<style scoped></style>
